import React from 'react';
import { Phone, Mail, MapPin } from 'lucide-react';
import { useSiteContent, trackEvent } from '../context/SiteContext';
import './Footer.css';

const Footer = () => {
  const { footer, settings } = useSiteContent();
  const currentYear = new Date().getFullYear();
  const phone = settings?.contactPhone || '+49 179 3912947';
  const email = settings?.contactEmail || 'event.service.woerth@gmail.com';

  const handleCallClick = () => { trackEvent('call_click'); };

  const handleCookieSettings = () => {
    window.dispatchEvent(new CustomEvent('openCookieSettings'));
  };

  return (
    <footer className="footer" data-testid="footer-section">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-title">BD Event Location</h3>
            <p className="body-small space-top-sm">{footer?.description || 'Ihre Premium-Location'}</p>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Kontakt</h4>
            <div className="footer-links space-top-sm">
              <a href={`tel:${phone}`} className="footer-link" onClick={handleCallClick} data-testid="footer-phone">
                <Phone size={16} /> {phone}
              </a>
              <a href={`mailto:${email}`} className="footer-link" data-testid="footer-email">
                <Mail size={16} /> {email}
              </a>
            </div>
          </div>
          <div className="footer-section">
            <h4 className="footer-heading">Adresse</h4>
            <div className="footer-address space-top-sm">
              <MapPin size={16} />
              <div>{footer?.address || 'Pfarrer-Adam-Haus-Strasse 6a'}<br />{footer?.city || '63939 Woerth am Main'}</div>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="body-small">&copy; {currentYear} BD Event Location. Alle Rechte vorbehalten.</p>
          <div className="footer-legal">
            <button className="footer-legal-link" onClick={() => window.location.href = '/impressum'}>Impressum</button>
            <button className="footer-legal-link" onClick={() => window.location.href = '/datenschutz'}>Datenschutz</button>
            <button className="footer-legal-link" onClick={handleCookieSettings} data-testid="footer-cookie-settings">Cookie-Einstellungen</button>
            <span className="footer-legal-link" style={{cursor: 'default', opacity: 0.7}}>Build by BA Media Performance</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
